import styled from 'styled-components';
import { Typography } from 'antd';

export const Label = styled(Typography.Paragraph)`
  font-size: 16px;
  margin-top: 20px;
  color: ${({ theme }) => theme.color.grey2};
`;

export const PoliciesOverlayLink = styled(Typography.Text)`
  font-size: 12px;
  color: ${({ theme }) => theme.color.grey2};
  text-decoration: underline;
`;
